<template>
  <img
    :src="logo"
    :alt="altLogo"
    aria-hidden="true"
    :class="['poster-logo', centered ? 'centered' : 'bottom-left', { 'hide-from-medium': visibility === LOGO_VISIBILITY.MOBILE }]"
    data-wptv="item-poster-channel">
</template>

<script>
import WptvPosterConfig from '../poster.config'

export default {
  name: 'PosterLogo',
  props: {
    logo: {
      type: String,
      required: true
    },
    altLogo: {
      type: String,
      required: true
    },
    visibility: {
      type: String,
      required: true
    },
    centered: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      LOGO_VISIBILITY: WptvPosterConfig.LOGO_VISIBILITY
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/abstracts/variables';
  @import '../../../scss/abstracts/mixins';

  .poster-logo {
    z-index: 3;
    object-fit: scale-down;
    @include mediaQueries('width', (xxsmall: 45px, xlarge: 60px));
    @include mediaQueries('height', (xxsmall: 45px, xlarge: 60px));
  }

  .bottom-left {
    position: absolute;
    bottom: 0;
    @include mediaQueries('left', (xxsmall: 50%, medium: 15px, xlarge: 20px));
    @include mediaQueries('top', (xxsmall: 50%, medium: unset));
    @include mediaQueries('bottom', (medium: 15px));
    @include mediaQueries('transform', (xxsmall: translate(-50%,-50%), medium: unset));
  }

  .centered {
    margin: auto;
  }
</style>
